import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useUpdateLeagueMemberScores = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();
  const apiUrl = process.env.REACT_APP_API_URL;

  return useMutation(
    async (eventId) => {
      const token = await getAccessTokenSilently();
      const response = await axios.post(
        `${apiUrl}/api/league/update-league-member-scores`,
        { eventId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        toast.success("League member scores updated successfully!");
        queryClient.invalidateQueries("leagueDetails");
        queryClient.invalidateQueries("leagueMembers");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred updating league member scores.";
        toast.error(errorMessage);
        console.error("Error updating league member scores:", errorMessage);
      },
    }
  );
};
